// extracted by mini-css-extract-plugin
export default {"folders-item":"FolderList_folders-item__W1bY8","folders-item-title":"FolderList_folders-item-title__pNuIG","list":"FolderList_list__CDRq3"};